import { IBreadCrumb } from './IBreadcrumb';

export class BreadCrumbData {
    breadcrumb: IBreadCrumb;
    title: string;
}
